<template>
    <div class="d-flex flex-column">
        <div class="d-flex align-items-center justify-content-between">
            <span class="font-sm font-weight-bold text-capitalize text-gray-dk">Installment Plan</span>
            <img alt="" v-if="dropdown" src="/img/hcpay/chevron.svg" class="dropdownIcon img-responsive clickable" :class="{ 'dropdownShown' : dropdownShown}" @click="dropdownShown = !dropdownShown" data-bs-toggle="collapse" data-bs-target="#installmentSummaryCollapse" :aria-expanded="dropdownShown" aria-controls="installmentSummaryCollapse">
        </div>
        <div class="collapse show" id="installmentSummaryCollapse">
            <div class="d-flex align-items-start my-4">
                <div class="col-6 col-xl-8 d-flex p-0">
                    <span class="font-sm productName">Loan Account No.</span>
                </div>
                <div class="col"></div>
                <div class="font-sm d-block col-5 col-xl-3 p-0 text-right">{{installmentDetails.loanAccountNumber}}</div>
            </div>
            <hr />
            <div class="d-flex align-items-start my-4">
                <div class="col-6 col-xl-8 d-flex p-0">
                    <span class="font-sm productName">
                        <b>Installment term</b>
                        <br />
                        <span class="font-xs text-secondary">Basket Financing</span>
                    </span>
                    
                </div>
                <div class="col"></div>
                <div class="font-sm d-block col-5 col-xl-3 p-0 text-right">{{installmentDetails.term}} months</div>
            </div>
            <hr />
            <div class="d-flex align-items-start my-4">
                <div class="col-6 col-xl-5 d-flex p-0">
                    <div class="font-sm productName">
                        <b>Monthly Installment</b>
                        <br />
                        <span class="font-xs text-secondary">inc. {{installmentDetails.interestRateInPercentage}}% monthly interest</span>
                    </div>
                </div>
                <div class="col"></div>
                <div class="font-lg d-block col-5 col-xl-5 p-0 text-right">₱ {{installmentDetails.monthlyInstallment}} / month</div>
            </div>
            <!-- div class="d-flex align-items-start my-4">
                <div class="col-6 col-xl-5 d-flex p-0">
                    <div class="font-sm productName">
                        <span class="text-secondary">Due dates</span>
                    </div>
                </div>
                <div class="col"></div>
                <div class="font-sm d-block col-5 col-xl-5 p-0 text-right">Every 1st of the month</div>
            </div>
            <div class="d-flex align-items-start my-4">
                <div class="col-6 col-xl-5 d-flex p-0">
                    <div class="font-sm productName">
                        <span class="text-secondary">First due date</span>
                    </div>
                </div>
                <div class="col"></div>
                <div class="font-sm d-block col-5 col-xl-5 p-0 text-right">May 1, 2024</div>
            </div>
            <div class="d-flex align-items-start my-4">
                <div class="col-6 col-xl-5 d-flex p-0">
                    <div class="font-sm productName">
                        <span class="text-secondary">Last due date</span>
                    </div>
                </div>
                <div class="col"></div>
                <div class="font-sm d-block col-5 col-xl-5 p-0 text-right">July 1, 2024</div>
            </div -->
            <hr />
            <div class="d-flex align-items-start my-4">
                <div class="col-6 col-xl-8 d-flex p-0">
                    <div class="font-sm productName">
                        <b>Processing fee</b>
                        <span data-bs-toggle="tooltip" 
                        data-bs-placement="top" 
                        data-bs-title="Processing fee is a monthly fee that we charge for processing your loan application and included in your monthly installment.">
                            <img alt="" src="/img/hcpay/information-icon.svg" class="accountTypeIcon img-responsive ml-1">
                        </span>
                        <span class="waive">Waived</span>
                        <br />
                        <span class="font-xs text-secondary">Included in monthly installment</span>
                    </div>
                </div>
                <div class="col"></div>
                <div class="font-sm d-block col-5 col-xl-3 p-0 text-right">₱ 0</div>
            </div>
            <hr />
        </div>
    </div>
</template>
<script>
$(function () {
  $('[data-bs-toggle="tooltip"]').tooltip()
})
export default {
    props: {
        dropdown: {
            type: Boolean,
            default: false
        },
        installmentDetails: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            dropdownShown : true,
            finalTotla: 0.00,
            productSum: 0.00
        }
    },
    methods: {
        toCurrency(value) {
            // Check if the value is NaN or empty (null, undefined, or other falsy values)
            if (!value || isNaN(value)) {
                value = 0;
            }
            let val = (value/1).toFixed(2).replace(',', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        getTotal() {
            return this.toCurrency(this.$root.$data.products.reduce((total,product) => total + product.amount,0));
        }        
    }
}
</script>
<style scoped>
    .dropdownIcon {
        height: auto;
        width: 0.8rem;
        transition-duration: 0.5s;
    }
    .dropdownShown {
        transform:rotate(-180deg);
    }
    .waive {
        color: #C8102E;
        font-size: 10px;
        font-weight: bold;
        border: 1px solid #C8102E;
        border-radius: 5px;
        padding: 2px 5px 2px 5px;
    }
</style>